import { render, staticRenderFns } from "./settings.view.vue?vue&type=template&id=3e312655&scoped=true&lang=pug"
import script from "./settings.view.vue?vue&type=script&lang=ts"
export * from "./settings.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e312655",
  null
  
)

export default component.exports